import React from "react";
import BrtxLinkCard from "../../componets/BrtxLinkCard";
import { Row } from "react-bootstrap";
import {
  FaDatabase,
  FaMoneyBillAlt,
  FaRegPlusSquare,
  FaInfo,
} from "react-icons/fa";

class Repair extends React.Component {
  state = {
    items: [
      {
        title: "Záruční podmínky",
        subtitle: "Podmínky pro uplatnění záruční opravy",
        link: "/info/warranty",
        icon: <FaDatabase className="c-white" />,
      },
      {
        title: "Zamítnutí záruční opravy",
        subtitle:
          "Naše společnost má přesně definované pravidla od výrobce, které musíme dodržovat",
        link: "/info/warrantyDeny",
        icon: <FaMoneyBillAlt className="c-white" />,
      },
      {
        title: "Založit požadavek na opravu",
        subtitle:
          "Jedná-li se o záruční opravu je nutno dodat zařízení s kompletním příslušenstvím!",
        link: "/repair/createRequest",
        icon: <FaRegPlusSquare className="c-white" />,
      },
    ],
  };
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaInfo className="c-placeholder c-green" />,
      Title: "Informace",
      SubTitle:
        "Zde se dozvíte veškeré potřebné informace před odesláním zařízení do opravy, jaké služby před odesláním vypnout a jak správně zásilku zabalit.",
    });
  }

  render() {
    return (
      <>
      <Row className="d-flex mt-4">
        {this.state.items.map((i, idx) => (
          <BrtxLinkCard {...this.props} {...i} idx={idx} />
        ))}
      </Row>
    </>
    );
  }
}

export default Repair;
